<!--<h2 class="font-bold text-2xl text-gray-600 my-2" [ngClass]="router.url == '/' ? 'hidden': 'block'">Enquire Now</h2>-->
<form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="mx-auto">
    <div *ngIf="showLimitedFields; else fullForm" class="flex gap-2">
        <div class="mb-4 w-full">
            <input type="text" id="name" formControlName="fullName" placeholder="Name"
                   class="mt-1 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
            <small *ngIf="submitted && enquiryForm.get('fullName')?.hasError('required')"
                   class="text-red-500">
                Name is required.
            </small>
        </div>
        <div class="w-full ">
            <div class="mb-4">
                <input type="number" id="contact" formControlName="contact" placeholder="Contact Number"
                       class="mt-1 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small *ngIf="submitted && enquiryForm.get('contact')?.hasError('required') "
                       class="text-red-500">
                    Contact number is required.
                </small>
            </div>
        </div>
        <div class="w-full ">
            <div class="mb-4">
                <input type="email" id="email" formControlName="email" placeholder="Email"
                       class="mt-1 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small
                    *ngIf="submitted && enquiryForm.get('email')?.hasError('required')"
                    class="text-red-500">
                    Email is required.
                </small>
                <small *ngIf="submitted && enquiryForm.get('email')?.hasError('email')" class="text-red-500">
                    Invalid email format.
                </small>
            </div>
        </div>
    </div>



    <ng-template #fullForm>
    <div class=" gap-2 flex">
        <div class="mb-4 w-full">
            <input type="text" id="name" formControlName="fullName" placeholder="Name"
                   class="mt-1 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
            <small *ngIf="submitted && enquiryForm.get('fullName')?.hasError('required')"
                   class="text-red-500">
                Name is required.
            </small>
        </div>
        <div class="w-full ">
            <div class="mb-4">
                <input type="number" id="contact" formControlName="contact" placeholder="Contact Number"
                       class="mt-1 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small *ngIf="submitted && enquiryForm.get('contact')?.hasError('required') "
                       class="text-red-500">
                    Contact number is required.
                </small>
            </div>
        </div>
    </div>
    <div class=" gap-3">

        <div class="w-full ">
            <div class="mb-4">
                <input type="email" id="email" formControlName="email" placeholder="Email"
                       class="mt-1 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small
                    *ngIf="submitted && enquiryForm.get('email')?.hasError('required')"
                     class="text-red-500">
                    Email is required.
                </small>
                <small *ngIf="submitted && enquiryForm.get('email')?.hasError('email')" class="text-red-500">
                    Invalid email format.
                </small>
            </div>
        </div>
        <div class="w-full">
            <div class="mb-4">
                <input type="text" id="organisation_name" formControlName="organisation_name" placeholder="Organisation Name"
                       class="mt-1 p-3 w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"/>
                <small *ngIf="submitted && enquiryForm.get('organisation_name')?.hasError('required') "
                       class="text-red-500">
                    Organisation number is required.
                </small>
            </div>
        </div>
    </div>
    <div class=" gap-3">
        <div class="w-full ">
            <div class="mb-4">
                <textarea type="text" id="issues" formControlName="issues" placeholder="Enter Problems Description"
                       class="mt-1 py-4 px-3  w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none resize-none"></textarea>
            </div>
        </div>
        <div class="w-full">
            <div class="mb-4">
                <textarea type="text" id="message" formControlName="message" placeholder="Drop Your Message"
                          class="mt-1 py-4 px-3 resize-none w-full border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:outline-none"></textarea>
            </div>
        </div>
    </div>
    <div [ngClass]="router.url == '/' ? 'text-center pt-4 border-t': 'pt-6x'">
        <button type="submit" class="bg-background  hover:bg-white text-white hover:text-blue-700  font-bold py-3 px-20 text-sm ">
            Submit
        </button>
    </div>
</ng-template>
</form>
<!-- Message Alert Box -->
<div  *ngIf="message" [ngClass]="messageType === 'success' ? 'alert-success' : 'alert-error'" class="alert">
    {{ message }}
</div>
